module.exports = __webpack_public_path__ + "img/collection-diamondJewelryPresentsWomen@2x.6cb2afe.webp";